import { combineReducers } from "redux";
import { tabsReducer } from "slices/tabsSlice";
import { authReducer } from "slices/authSlice";
import mattersReducer from "./matters.reducer";
import { filesDownloadReducer } from "services/filesDownloadService";
import { contactsReducer } from "services/contactsService";
import { tasksReducer } from "services/tasksService";
import { timeReducer } from "services/timeService";
import ledgerLinks from "./ledgerlinks.reducer";
import chitPostingReducer from "./chitPosting.reducer";
import clientsReducer from "./clients.reducer";
import BillingRequestsReducer from "./billingRequests.reducer";
import ctoSweepReducer from "./ctosweep.reducer";
import { branchReducer } from "services/branchService";
import { vatReducer } from "services/vatService";
import { expenseReducer } from "services/expenseService";
import { currentUserReducer } from "services/currentUserService";
import { currentUserSettingsReducer } from "services/userSettingsService";
import { accountSettingsReducer } from "services/accountSettingsService";
import { usersReducer } from "services/userService";
import { departmentReducer } from "services/departmentService";
import { workTypeReducer } from "services/workTypeService";
import { supplierReducer } from "services/supplierService";
import { companyReducer as CompanyServiceReducer } from "services/companyService";
import { activityTypeReducer } from "services/activityTypeService";
import { activityTagReducer } from "services/activityTagService";
import { ledgerCardSettingsReducer } from "services/ledgerCardSettingsService";
import { timeTypeReducer } from "services/timeTypeService";
import { dashboardReducer } from "services/dashboardService";
import { applicationSettingsReducer } from "services/applicationSettingsService";
import { nominalsReducer } from "services/nominalsService";
import { currencyReducer } from "services/currencyService";
import { countryReducer } from "services/countriesService";
import { applicationReducer } from "services/applicationService";
import { docTypeReducer } from "services/docTypeService";
import dialogReducer from "slices/errorDialogSlice";
import accessDeniedReducer from "slices/accessDeniedSlice";
import { referrerReducer } from "services/referrersService";
import { sourceReducer } from "services/sourcesService";
import { fixedFeeHeaderReducer } from "services/fixedfeeService";
import { transactionPeriodReducer } from "services/transactionPeriodService";
import { contactCategoriesReducer } from "services/contactCategoriesService";

const rootReducer = combineReducers({
  tabsData: tabsReducer,
  mattersList: mattersReducer,
  contactsList: contactsReducer,
  tasksList: tasksReducer,
  nominals: nominalsReducer,
  suppliers: supplierReducer,
  currentUser: currentUserReducer,
  currentUserSettings: currentUserSettingsReducer,
  accountSettings: accountSettingsReducer,
  users: usersReducer,
  company: CompanyServiceReducer,
  time: timeReducer,
  branches: branchReducer,
  vats: vatReducer,
  expenses: expenseReducer,
  currencies: currencyReducer,
  transactionPeriods: transactionPeriodReducer,
  auth: authReducer,
  filesDownload: filesDownloadReducer,
  ledgerLinks: ledgerLinks,
  chitPosting: chitPostingReducer,
  clients: clientsReducer,
  workTypes: workTypeReducer,
  departments: departmentReducer,
  dashboard: dashboardReducer,
  referrers: referrerReducer,
  sources: sourceReducer,
  docTypes: docTypeReducer,
  billingRequests: BillingRequestsReducer,
  ctoSweep: ctoSweepReducer,
  activityTypes: activityTypeReducer,
  activityTags: activityTagReducer,
  timeTypes: timeTypeReducer,
  applicationSettings: applicationSettingsReducer,
  applicationsData: applicationReducer,
  errorDialog: dialogReducer,
  accessDenied: accessDeniedReducer,
  fixedFee: fixedFeeHeaderReducer,
  contactCategories: contactCategoriesReducer,
  ledgerCardSettings: ledgerCardSettingsReducer,
  countries: countryReducer,
});

export default rootReducer;
